module.exports = __webpack_public_path__ + "static/media/5.21.5e6b263c.png";